// ----------------------------------------------------------------------------
// Snippet: Announcement Bar
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// Styles
import './_announcement-bar.scss';
